import axios from 'axios';
export default function(options = {}) {

  function currencyFormat(price, countryCode, currencyCode) {
    return new Intl.NumberFormat(
      'en-GB',
      {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0,
      }).format(price);
  }

  return {

    price: null,
    compareAtPrice: null,
    currencyCode: null,
    noVariant: false,

    init() {

      // Watch for change in variant if inside a product page (inherited variable)
      this.$watch('currentVariantId', () => {
        this.fetchPrice();
      });

      this.price = options.price;
      this.compareAtPrice = options.compareAtPrice;

      if(!this.price) {
        this.fetchPrice();
      }
    },

    fetchPrice() {
      if(this.currentVariantId === null) {
        this.noVariant = true;
        return;
      }

      const variantId = this.currentVariantId || options.variantId;

      axios({
        url: '/actions/site-module/shopify/country-pricing',
        method: 'get',
        params: { variantId: variantId, countryCode: options.countryCode }
      })
        .then(resp => {
          this.noVariant = false;
          this.price = currencyFormat(resp.data.price, options.countryCode, resp.data.currencyCode);
          if(resp.data.compareAtPrice) {
            this.compareAtPrice = currencyFormat(resp.data.compareAtPrice);
          }
        })
        .catch(err => {
          this.error = true;
        });
    }
  };

}
